/* globals Routes */

import React from 'react'
import styles from './RightSidebar.scss'
import {Sidebar} from 'features/recumbent/PlannerSidebar/Sidebar'
import {CTA} from 'common/styleguide/CTA'
import {CueForm} from './CueForm'

class ReviewFinished extends React.PureComponent {
  save () {
    this.props.onBeforeSave && this.props.onBeforeSave()

    Routes.New.saveRoute()
  }

  render () {
    const {cues, onReturn, onDismiss} = this.props

    console.log('cues', cues)

    return (
      <div>
        <h2>Route Complete!</h2>
        <div>
          Your review is complete! Save your route, or return the editor.
        </div>
        <CTA onClick={onReturn}>Return to Route Editor</CTA>
        <CTA secondary onClick={() => this.save()}>Save</CTA>
        <CTA secondary onClick={() => !!cues.size && onDismiss()} disabled={!cues.size}>Keep Reviewing</CTA>
      </div>
    )
  }
}

export class RightSidebar extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      finishedDismissed: props.cues.every((c) => c.confirmed)
    }
  }

  dismissReviewFinished () {
    this.setState({
      finishedDismissed: true
    })
  }

  render () {
    const {cues, currentCue, onClose, onConfirm, onPrevious, onDelete, removeCues} = this.props

    const sidebarProps = Routes.New.mapCommand
    const smallSidebarProps = {
      setCallbacks: {
        createPoi: sidebarProps.setCallbacks.createPoi,
        addCue: sidebarProps.setCallbacks.addCue
      },
      unsetCallbacks: sidebarProps.unsetCallbacks,
      selectedCommand: 'addCue'
    }

    const reviewFinished = !this.state.finishedDismissed && cues.every((c) => c.confirmed === true)

    return (
      <div className={styles.RightSidebar}>
        <div className={styles.header}>
          Review Cue
          <div className={styles.closeIcon} onClick={onClose}>×</div>
        </div>
        <div className={styles.scrollContainer}>
          <div className={styles.topHalf}>
            {!reviewFinished && <CueForm currentCue={currentCue} onConfirm={onConfirm} onPrevious={onPrevious} onDelete={onDelete} />}
            {reviewFinished && <ReviewFinished cues={cues} onBeforeSave={removeCues} onReturn={onClose} onDismiss={() => this.dismissReviewFinished()} />}
          </div>
          {!reviewFinished && <div className={styles.bottomHalf}>
            <Sidebar showRouteOptions={false} {...smallSidebarProps} />
            Return to the route editor for full edit options.
            <CTA onClick={onClose}>Close Review</CTA>
          </div> }
        </div>
      </div>
    )
  }
}
